import React,{useEffect,useState} from 'react'
import service from '../../services';
import FilterIcon from './../../icons/filtericon';
import FilterActiveIcon from './../../icons/filteractiveicon';
import Loader from './../../component/loader';
import ReactPaginate from "react-paginate";

let sub;
let programFilterList = []
function Allotments(props){
    const [apiserve, setApiserve] = useState(new service());
    const [allotmentData, setAallotmentData] = useState([]);
    const [loader, setLoader] = useState(true);
    const [totalloader, setTotalLoader] = useState(false);
    const [pageCount, setpageCount] = useState();
    const [perPage, setperPage] = useState(50);
    const [currentPage, setcurrentPage] = useState(0);
    const [offset, setOffset] = useState(0);
    const [filmList, setFilmList] = useState([]);
    const [programArray, setProgramArray] = useState([]);
    const [awardCategoryArray, setAwardCategoryArray] = useState([]);
    const [categoryArray, setCategoryArray] = useState([]);
    const [filmDetail,setfilmDetail] = useState()
    const [dropdownId,setDropdownId] = useState()
    const [grandtotal,setGrandtotal] = useState()

    useEffect(() => {
        apiserve.sendevent("user|sff|getAllInitial", {});
        apiserve.sendevent("admin|screening|getGrandTotalScreening", {});
        setTotalLoader(true)

        sub = apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "user|sff|getAllInitial":
                   var programData =  response.data.film && response.data.film.category.map(function (el) {
                        let o = Object.assign({}, el);
                        o.value = false;
                        return o;
                    });
                    var awardCategoryData =  response.data.film && response.data.film.awardCategory.map(function (el) {
                        let o = Object.assign({}, el);
                        o.value = false;
                        return o;
                    });
                    // setFilmList(response?.data?.film)
                    setProgramArray(programData)
                    // setAwardCategoryArray(awardCategoryData)
                    setCategoryArray(response?.data?.film?.category)
                    let currentPage = localStorage.getItem('currentPage')
                    if(currentPage) {
                        setOffset(parseInt(localStorage.getItem("offset")))
                        setperPage(parseInt(localStorage.getItem("perPage")))
                        setcurrentPage(parseInt(localStorage.getItem("currentPage")))
                        getFilmList(parseInt(localStorage.getItem("offset")),parseInt(localStorage.getItem("perPage")))
                    }else{
                        setOffset(offset)
                        setperPage(perPage)
                        setcurrentPage(currentPage)
                        getFilmList(offset,perPage)
                }
                break;
                case "admin|screening|getList":
                    if (!response.error) {
                        setLoader(false)
                        setpageCount(response?.data?.filmDetails?.totalDocs / perPage)
                        setAallotmentData(response?.data?.filmDetails?.docs)
                    } else {
                        setLoader(false)
                    }
                    break;
                
                case "admin|screening|getScreeningList":
                    if (!response.error) {
                        setLoader(false)
                        setfilmDetail(response?.data?.filmDetails)
                    }
                    break;
                case "admin|screening|getGrandTotalScreening":
                    if (!response.error) {
                        setTotalLoader(false)
                        setGrandtotal(response?.data?.grandTotal)
                    }else{
                        setTotalLoader(false)
                    }
                    break;
            }
        })

        return () => {
            sub.unsubscribe();
            programFilterList = []
        }
    }, [])

    

   
    const handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + 1;
        // page scroll top
        var tbl = document.querySelector(".film_list_table");
        tbl.scrollTo(0, 0);
        setcurrentPage(selectedPage)
        setOffset(offset)
        localStorage.setItem('currentPage',selectedPage);
        localStorage.setItem('offset',offset);
        localStorage.setItem('perPage',perPage);
        getFilmList(offset,perPage)
       
    };

    const getFilmList = (skip, limit) => {
        setLoader(true)
        var data = {}
       
        if (programFilterList && programFilterList.length) {
            data.category = programFilterList
        }
        data.page = skip
        data.limit = limit
        // apiserve.sendevent("admin|screening|getList", data)
        
    }


    const getFilmFilter = (skip,limit,isClearStatusType,isClearProgramType,isClearAwardType) =>{
        
        let data = {
            page: 1,
            limit: limit
        }
        if (!isClearProgramType && programFilterList && programFilterList.length) {
            data.category = programFilterList
        }
        // apiserve.sendevent("admin|screening|getList", data);
    }


    const programFilter = (e, selectedInex,isClearStatusType ,isClearProgramType = false) => {
        
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let approvePassList = [...programArray]
        approvePassList.forEach((key, i) => {
            if(i === index) {
                approvePassList[i].value = event
            }
            if(isClearProgramType) {
                approvePassList[i].value = false
                programFilterList=[]
            }
            setProgramArray(approvePassList)
            setcurrentPage(0)

            if (event) {
                if (index !== null) {
                    programFilterList = [...programFilterList, programArray[index]._id];
                }         
                    
            } else {
                if (index !== null) {
                    let tempArray = programFilterList.filter((d) => d !== programArray[index]._id);
                    programFilterList = tempArray; 
                }
            }
        })
        getFilmFilter(offset, perPage,isClearStatusType,isClearProgramType);
    }
    const getAlotment = (e,filmId) => {
        if(filmId === dropdownId){	
            setDropdownId('')	
        }else{	
            setDropdownId(filmId)	
            let data = {filmId:filmId}
            setLoader(true)
            apiserve.sendevent("admin|screening|getScreeningList", data);
        }
    }


    return (
        <>
                <div className="film_list_table allotment_table">
                    <div className="">
                        
                        <table className="tbl_layout_fix" style={{maxWidth:"520px"}}>
                            <tr>
                                <th style={{width:"200px"}}><h3 className="ml_10 pt_10 mb_10">Total: {grandtotal?.totalAllow || 0}/{grandtotal?.totalOpted || 0}/{grandtotal?.totalConsumed || 0}</h3></th>
                                <th style={{width:"120px"}}>
                                    <span className="disp_flex d_flex_align_center"> Category 
                                        {props.programFilterList && props.programFilterList.length ?
                                            <FilterActiveIcon /> 
                                            :
                                            <FilterIcon /> 
                                        }
                                    </span> 
                                    <div className="tabelData_popup" style={{right:"0"}}>
                                        <form>
                                            <div className="customCheck">
                                                <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                    <p className="link" onClick={() => props.programFilter(null,null,null,true)}>Clear All</p>
                                                </div>
                                                
                                                <div className="customCheckBox">
                                                {props.programArray.map((item,i)=>(
                                                    <div className="customCheckBox">
                                                    <input
                                                        type="checkbox"
                                                        id={item._id}
                                                        name={item._id}
                                                        value={item.value ? true : false}
                                                        checked={item.value ? true : false}
                                                        onClick={(e) => props.programFilter(e, i)}
                                                    />
                                                    <label htmlFor={item._id}>{item.name}</label>
                                                    </div>
                                                    ))
                                                }
                                                </div>
                                                </div>
                                        </form>
                                    </div> 
                                </th>
                            </tr>
                        </table>
                    </div>
                    {/* <h4 className="pl_15"> Title </h4> */}
                    <ul className="w_100 allotment_tbl">
                            {
                                props.allotmentData?.length >= 0 && props.allotmentData.map((list) => {
                                    return (
                                        <>
                                            <li className={`d_flex d_flex_justify_spacebt pointer ${props.dropdownId === list._id ?  'active' : ''}`} onClick={(e) => props.getAlotment(e,list._id)}>
                                                <div>{list?.title}</div>
                                                <span>
                                                    <svg width="21" height="13" viewBox="0 0 21 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M1.30761 1.19238L10.5 10.3848L19.6924 1.19238" stroke="black" stroke-width="2.5"/>
                                                    </svg>
                                                </span>
                                            </li>
                                            {
                                                props.dropdownId === list._id ?
                                                <div className="all_dropdown_content">
                                                    <table className="tbl_layout_fix">
                                                        <tr>
                                                            <th style={{width:"320px"}}>  </th>
                                                            <th style={{width:"320px"}}> 
                                                                <div className="mb_25"></div>
                                                                <span className="disp_flex d_flex_align_center">
                                                                    Category 
                                                                </span> 
                                                            </th>
                                                            <th className="text_center" style={{width:"80px"}}>
                                                                <div className="mb_25"></div>
                                                                Waitlist</th>
                                                            <th className="text_center" style={{width:"80px"}}>
                                                                <div className="mb_25"></div>
                                                                Hold</th>
                                                            <th style={{width:"320px"}}> 
                                                                <div className="mb_5" style={{marginLeft:"85px"}}>Totals</div>
                                                                <div className="disp_flex d_flex_align_center">
                                                                    <p className="text_center" style={{width:"130px"}}>In-Person</p>               
                                                                    <p className="text_center" style={{width:"130px"}}>Online</p>               
                                                                    <p style={{width:"130px"}}></p>               
                                                                </div>
                                                            </th> 
                                                            <th style={{width:"320px"}}> 
                                                                <div className="mb_5" style={{marginLeft:"85px"}}>Premiere</div>
                                                                <div className="disp_flex d_flex_align_center">
                                                                    <p className="text_center" style={{width:"70px"}}>Allowed</p>               
                                                                    <p className="text_center" style={{width:"70px"}}>Opted</p>               
                                                                    <p className="text_center" style={{width:"70px"}}>Consumed</p>               
                                                                    <p style={{width:"115px"}}></p>               
                                                                </div>
                                                            </th>
                                                            <th style={{width:"320px"}}> 
                                                                <div className="mb_5" style={{marginLeft:"45px"}}>Second Screening</div>
                                                                <div className="disp_flex d_flex_align_center">
                                                                    <p className="text_center" style={{width:"70px"}}>Allowed</p>               
                                                                    <p className="text_center" style={{width:"70px"}}>Opted</p>               
                                                                    <p className="text_center" style={{width:"70px"}}>Consumed</p>               
                                                                    <p style={{width:"115px"}}></p>               
                                                                </div>
                                                            </th>
                                                            <th style={{width:"220px"}}> 
                                                                <div className="mb_5" style={{marginLeft:"45px"}}>Award Winner</div>
                                                                <div className="disp_flex d_flex_align_center">
                                                                    <p className="text_center" style={{width:"70px"}}>Allowed</p>               
                                                                    <p className="text_center" style={{width:"70px"}}>Opted</p>               
                                                                    <p className="text_center" style={{width:"70px"}}>Consumed</p>               
                                                                </div>
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <td style={{width:"320px"}}>
                                                                <div className="disp_flex">
                                                                    <div className="film_banner">
                                                                        <img src={ props.filmDetail?.images.inSite ? process.env.REACT_APP_IMAGE_URL + props.filmDetail?.images.inSite :
                                                                            props.filmDetail?.images.link ? props.filmDetail?.images.link :
                                                                                 '/images/image-placeholder.png'} alt="film image" />
                                                                       
                                                                    </div>
                                                                    <div className="film_desc">
                                                                        <h3>{props.filmDetail?.title}</h3>
                                                                        <div className="disp_flex d_flex_align_center">
                                                                            <span>{props.filmDetail?.runTime} min</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td style={{width:"320px"}}>
                                                                <p> {props.filmDetail?.category?.name} </p>
                                                            </td>
                                                            <td className="pl_0 pr_0" style={{width:"80px"}}>
                                                                <div className="font_700 in_price waitlist_bg text_center">{props.filmDetail?.screening?.total?.inperson?.waitList}</div>            
                                                            </td>
                                                            <td className='pl_0 pr_0' style={{width:"80px"}}>
                                                                <div className='single_row'>
                                                                    <p style={{minHeight:"38px"}} className='font_700 text_center in_price'>{props.filmDetail?.screening?.total?.holdTickets?.allowed}</p>
                                                                </div> 
                                                                <div  className='pub_pkg_row'>
                                                                    <p style={{minHeight:"40px"}} className='font_700 text_center in_price'>{props.filmDetail?.screening?.total?.holdTickets?.opted}</p>
                                                                </div> 
                                                                <div  className='pi_row'>
                                                                    <p style={{minHeight:"37px"}} className='font_700 text_center in_price'>{props.filmDetail?.screening?.total?.holdTickets?.consumed}</p>
                                                                </div>           
                                                            </td>
                                                            <td style={{width:"320px",paddingLeft:"0",paddingRight:"0"}}>
                                                                <div className="disp_flex d_flex_align_center single_row">
                                                                    <p className="font_700 text_center in_price" style={{width:"115px"}}>{props.filmDetail?.screening?.total?.inperson?.allowed}</p>               
                                                                    <p className="font_700 text_center in_price" style={{width:"115px"}}>{props.filmDetail?.screening?.total?.online?.allowed}</p>               
                                                                    <p className="ticket_title" style={{width:"115px"}}>Single Tickets</p>               
                                                                </div>
                                                                <div className="disp_flex d_flex_align_center pub_pkg_row">
                                                                    <p className="font_700 text_center in_price" style={{width:"115px"}}>{props.filmDetail?.screening?.total?.inperson?.opted}</p>               
                                                                    <p className="font_700 text_center in_price" style={{width:"115px"}}>{props.filmDetail?.screening?.total?.online?.opted}</p>               
                                                                    <p className="ticket_title" style={{width:"115px"}}>Public Packages</p>               
                                                                </div>
                                                                <div className="disp_flex d_flex_align_center pi_row">
                                                                    <p className="font_700 text_center in_price" style={{width:"115px"}}>{props.filmDetail?.screening?.total?.inperson?.consumed}</p>               
                                                                    <p className="font_700 text_center in_price" style={{width:"115px"}}>
                                                                    {props.filmDetail?.screening?.total?.online?.consumed}</p>               
                                                                    <p className="ticket_title" style={{width:"115px"}}>P&I Packages</p>               
                                                                </div>
                                                            </td>
                                                            <td style={{width:"320px",paddingLeft:"0",paddingRight:"0"}}>
                                                                <div className="disp_flex d_flex_align_center single_row">
                                                                    <p className="font_700 text_center allowed" style={{width:"70px"}}>{props.filmDetail?.screening?.premiere?.singleTickets?.totalAllow}</p>               
                                                                    <p className="font_700 text_center Opted" style={{width:"70px"}}>
                                                                    {props.filmDetail?.screening?.premiere?.singleTickets?.totalOpted}
                                                                        </p>               
                                                                    <p className="Consumed text_center" style={{width:"70px"}}>
                                                                    {props.filmDetail?.screening?.premiere?.singleTickets?.totalConsumed}
                                                                        </p>               
                                                                    <p className="ticket_title" style={{width:"115px"}}>Single Tickets</p>               
                                                                </div>
                                                                <div className="disp_flex d_flex_align_center pub_pkg_row">
                                                                    <p className="font_700 text_center allowed" style={{width:"70px"}}>{props.filmDetail?.screening?.premiere?.publicPackageTicket?.totalAllow}</p>               
                                                                    <p className="font_700 text_center Opted" style={{width:"70px"}}>{props.filmDetail?.screening?.premiere?.publicPackageTicket?.totalOpted}</p>               
                                                                    <p className="Consumed text_center" style={{width:"70px"}}>
                                                                    {props.filmDetail?.screening?.premiere?.publicPackageTicket?.totalConsumed}
                                                                    </p>               
                                                                    <p className="ticket_title" style={{width:"115px"}}>Public Packages</p>               
                                                                </div>
                                                                <div className="disp_flex d_flex_align_center pi_row">
                                                                    <p className="font_700 text_center allowed" style={{width:"70px"}}>{props.filmDetail?.screening?.premiere?.piPackageTicket?.totalAllow}</p>               
                                                                    <p className="font_700 text_center Opted" style={{width:"70px"}}>{props.filmDetail?.screening?.premiere?.piPackageTicket?.totalOpted}</p>               
                                                                    <p className="Consumed text_center" style={{width:"70px"}}>{props.filmDetail?.screening?.premiere?.piPackageTicket?.totalConsumed}</p>               
                                                                    <p className="ticket_title" style={{width:"115px"}}>P&I Packages</p>               
                                                                </div>
                                                            </td>
                                                            <td style={{width:"320px",paddingLeft:"0",paddingRight:"0"}}>
                                                                <div className="disp_flex d_flex_align_center single_row">
                                                                    <p className="font_700 text_center allowed" style={{width:"70px"}}>{props.filmDetail?.screening?.second_screening?.singleTickets?.totalAllow}</p>               
                                                                    <p className="font_700 text_center Opted" style={{width:"70px"}}>
                                                                    {props.filmDetail?.screening?.second_screening?.singleTickets?.totalOpted}</p>               
                                                                    <p className="Consumed text_center" style={{width:"70px"}}>
                                                                    {props.filmDetail?.screening?.second_screening?.singleTickets?.totalConsumed}</p>               
                                                                    <p className="ticket_title" style={{width:"115px"}}>Single Tickets</p>               
                                                                </div>
                                                                <div className="disp_flex d_flex_align_center pub_pkg_row">
                                                                    <p className="font_700 text_center allowed" style={{width:"70px"}}>{props.filmDetail?.screening?.second_screening?.publicPackageTicket?.totalAllow}</p>               
                                                                    <p className="font_700 text_center Opted" style={{width:"70px"}}>{props.filmDetail?.screening?.second_screening?.publicPackageTicket?.totalOpted}</p>               
                                                                    <p className="Consumed text_center" style={{width:"70px"}}>
                                                                    {props.filmDetail?.screening?.second_screening?.publicPackageTicket?.totalConsumed}</p>               
                                                                    <p className="ticket_title" style={{width:"115px"}}>Public Packages</p>               
                                                                </div>
                                                                <div className="disp_flex d_flex_align_center pi_row">
                                                                    <p className="font_700 text_center allowed" style={{width:"70px"}}>{props.filmDetail?.screening?.second_screening?.piPackageTicket?.totalAllow}</p>               
                                                                    <p className="font_700 text_center Opted" style={{width:"70px"}}>{props.filmDetail?.screening?.second_screening?.piPackageTicket?.totalOpted}</p>               
                                                                    <p className="Consumed text_center" style={{width:"70px"}}>{props.filmDetail?.screening?.second_screening?.piPackageTicket?.totalConsumed}</p>               
                                                                    <p className="ticket_title" style={{width:"115px"}}>P&I Packages</p>               
                                                                </div>
                                                            </td>
                                                            <td style={{width:"220px",paddingLeft:"0",paddingRight:"0"}}>
                                                                <div className="disp_flex d_flex_align_center single_row">
                                                                    <p className="font_700 text_center allowed" style={{width:"70px"}}>{props.filmDetail?.screening?.award_winner?.singleTickets?.totalAllow}</p>               
                                                                    <p className="font_700 text_center Opted" style={{width:"70px"}}>{props.filmDetail?.screening?.award_winner?.singleTickets?.totalOpted}</p>               
                                                                    <p className="Consumed text_center" style={{width:"70px"}}>
                                                                    {props.filmDetail?.screening?.award_winner?.singleTickets?.totalConsumed}</p>               
                                                                    {/* <p className="ticket_title" style={{width:"115px"}}>Single Tickets</p>                */}
                                                                </div>
                                                                <div className="disp_flex d_flex_align_center pub_pkg_row">
                                                                    <p className="font_700 text_center allowed" style={{width:"70px"}}>{props.filmDetail?.screening?.award_winner?.publicPackageTicket?.totalAllow}</p>               
                                                                    <p className="font_700 text_center Opted" style={{width:"70px"}}>{props.filmDetail?.screening?.award_winner?.publicPackageTicket?.totalOpted}</p>               
                                                                    <p className="Consumed text_center" style={{width:"70px"}}>
                                                                    {props.filmDetail?.screening?.award_winner?.publicPackageTicket?.totalConsumed}</p>               
                                                                    {/* <p className="ticket_title" style={{width:"115px"}}>Public Packages</p>                */}
                                                                </div>
                                                                <div className="disp_flex d_flex_align_center pi_row">
                                                                    <p className="font_700 text_center allowed" style={{width:"70px"}}>{props.filmDetail?.screening?.award_winner?.piPackageTicket?.totalAllow}</p>               
                                                                    <p className="font_700 text_center Opted" style={{width:"70px"}}>{props.filmDetail?.screening?.award_winner?.piPackageTicket?.totalOpted}</p>               
                                                                    <p className="Consumed text_center" style={{width:"70px"}}>{props.filmDetail?.screening?.award_winner?.piPackageTicket?.totalConsumed}</p>               
                                                                    {/* <p className="ticket_title" style={{width:"115px"}}>P&I Packages</p>                */}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                :''
                                            }
                                        </>
                                    )
                                })
                            }
                           
                    </ul>
                   
                </div>
                {allotmentData.length > 0 ? (
                    <div className="custom-pagination">
                        <ReactPaginate
                            previousLabel={""}
                            nextLabel={""}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={props.pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(e) => props.handlePageClick(e)}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"}
                            forcePage={currentPage}
                        />
                    </div>
                ) : (
                        ""
                    )}
            { (loader || totalloader) ? <Loader/> :'' }
        </>
    )
}

export default Allotments;